import {State} from '../../types/state'
import {getPlacesInBasket} from './places'

export const getSeatingError = (state: State) => state.seating.errors.error

export const getSeatingErrorPlanPlaceId = (state: State) => state.seating.errors.planPlaceId

export const getPlaceDonationError = (state: State, placeId: string) => state.seating.errors.donationErrors[placeId]

export const getFirstPlaceWithDonationError = (state: State) =>
  getPlacesInBasket(state).find(place => getPlaceDonationError(state, place.id))
